/**
 * Universal logger — uses winston on the server, falls back to console on the client.
 * This allows both server and client components to `import logger from "@/lib/logger"`
 * without triggering "Can't resolve 'fs'" errors during bundling.
 */

const isServer = typeof window === "undefined";

interface Logger {
  debug: (message: string, ...args: unknown[]) => void;
  info: (message: string, ...args: unknown[]) => void;
  warn: (message: string, ...args: unknown[]) => void;
  error: (message: string, ...args: unknown[]) => void;
  redact: (value: unknown) => unknown;
}

// Client-side: simple console wrapper
const clientLogger: Logger = {
  debug: console.debug.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  redact: (v: unknown) => v,
};

let logger: Logger;

if (!isServer) {
  logger = clientLogger;
} else {
  // Dynamic require to prevent bundler from pulling winston into client bundles
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { createServerLogger } = require("./logger.server");
  logger = createServerLogger();
}

export default logger;
